export default __webpack_public_path__ + "static/media/person_contoh.f6ece635.png";